import TypeFormInputRadio from './TypeFormInputRadio';

import { Types } from '../../../utils/DynamicForm.config';

const defaultItems = [
	{ text: 'Sí', value: 1 },
	{ text: 'No', value: 0 }
];

const TypeFormInputBoolean = ({ items: propItems, ...props }) => {
	const items = Array.isArray(propItems) && propItems.length
		? propItems.map((item) => ({ text: item.label || item.text, value: item.value }))
		: defaultItems;
	return TypeFormInputRadio({
		...props,
		items
	});
};

TypeFormInputBoolean.propTypes = {
	...Types.inputType,
	items: Types.inputOptionsType.isRequired
};

export default TypeFormInputBoolean;
